export const DietDietaryGroup = (json: IDietDietaryGroup): IDietDietaryGroupModel => {
	const { group_id, group_name, production_stage_assignments, updated_at, created_at } = json

	return {
		id: group_id,
		name: group_name,
		productionStageAssignments: Array.isArray(production_stage_assignments)
			? production_stage_assignments.map(DietProductionStageAssignment)
			: null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		createdAt: created_at ? new Date(created_at) : null,
	}
}

/**
 * Forms
 */
export const DietDietaryGroupModelToForm = (model: IDietDietaryGroupModel, order: number): IDietDietaryGroupForm => {
	const { ...rest } = model

	return {
		...rest,
		order,
	}
}

/**
 * Payloads
 */
export const DietDietaryGroupToPayload = (model: IDietDietaryGroupForm): IDietDietaryGroupPayload => {
	const { id, name } = model

	return {
		name,
		internal_id: id,
	}
}
